itsoftApp.createModule("infoBox", function () {
    const module = this;

    const init = function (el) {
        const infoButtons = el.querySelectorAll("[data-info]");
        let generalClose = null;

        if (!infoButtons.length) {
            return;
        }

        const onBoxClick = function (evt) {
            const box = evt.currentTarget;
            const boxArea = evt.target;

            if (!boxArea.closest(".info-box__content")){
                box.closest("[data-info-parent]").classList.remove("js-index");
                box.classList.remove("js-hover");
                box.classList.remove("js-active");
            }
        }

        const onBoxOver = function (evt) {
            const box = evt.currentTarget;
            box.closest("[data-info-parent]").classList.add("js-index");
            box.classList.add("js-active");
            box.classList.add("js-hover");
        }

        const onBoxOut = function (evt) {
            const box = evt.currentTarget;
            box.closest("[data-info-parent]").classList.remove("js-index");
            box.classList.remove("js-hover");
            // box.removeEventListener("click", onBoxClick);
        }

        const onButtonOver = function (evt) {
            const target = evt.currentTarget;
            const id = target.getAttribute("data-info");
            const box = document.querySelector("[data-box='" + id + "']");
            target.closest("[data-info-parent]").classList.add("js-index");
            box.classList.add("js-active");
            box.classList.add("js-hover");
            // box.addEventListener("click", onBoxClick);
        }

        const onButtonOut = function (evt) {
            const target = evt.currentTarget;
            const id = target.getAttribute("data-info");
            const box = document.querySelector("[data-box='" + id + "']");
            // if (!box.classList.contains("js-active")) {
                target.closest("[data-info-parent]").classList.remove("js-index");
            // }
            box.classList.remove("js-hover");
            // box.removeEventListener("click", onBoxClick);
        }

        const onCloseButtonClick = function (evt) {
            evt.preventDefault();
            const target = evt.currentTarget;
            target.closest("[data-info-parent]").classList.remove("js-index");
            target.closest("[data-box]").classList.remove("js-active");
            target.closest("[data-box]").classList.remove("js-hover");
            // target.removeEventListener("click", onBoxClick);
        }

        const onGeneralCloseButtonClick = function () {
            evt.preventDefault();
            const target = evt.currentTarget;
            target.closest("[data-info-parent]").classList.remove("js-index");
            target.closest("[data-info-parent]").classList.remove("js-active");

            infoButtons.forEach(function (button) {
                const id = button.getAttribute("data-info");
                const box = document.querySelector("[data-box='" + id + "']");
                box.classList.remove("js-active");
                box.classList.remove("js-hover");
            });
        }

        infoButtons.forEach(function (button) {
            const id = button.getAttribute("data-info");
            const box = document.querySelector("[data-box='" + id + "']");
            const closeBtn = box.querySelector("[data-close]");

            closeBtn && closeBtn.addEventListener("click", onCloseButtonClick);

            button.addEventListener("mouseover", onButtonOver);
            button.addEventListener("mouseout", onButtonOut);
            box.addEventListener("mouseover", onBoxOver);
            box.addEventListener("mouseout", onBoxOut);
        });
    }

    module.init = init;
 });